// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__36-E5","validationTips":"StatementDescriptor_validationTips__2fk7n"};